import React from 'react';

import {RegisterOptions} from 'react-hook-form';

import InputText, {IInputTextProps} from './InputText';


const InputName: React.FC<IInputTextProps> = (props) => {

    const NAME_PATTERN = /^.{2,}$/;// eslint-disable-line

    const rules: RegisterOptions = {
        pattern: {value: NAME_PATTERN, message: 'Некорректное значение'},
        required: 'Не указано значение',
    };

    return (
        <InputText
            rules={rules}
            {...props}
        />
    );
};

export default InputName;